import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import 'antd/dist/antd.css';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import * as Sentry from '@sentry/react';
import App from 'App';
import 'index.css';

import translationVI from './assets/languages/vi.json';
import translationEN from './assets/languages/en.json';

const ignoreErrors = [
  // Random plugins/extensions
  "top.GLOBALS",
  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  "originalCreateNotification",
  "canvas.contentDocument",
  "MyApp_RemoveAllHighlights",
  "http://tt.epicplay.com",
  "Can't find variable: ZiteReader",
  "jigsaw is not defined",
  "ComboSearch is not defined",
  "http://loading.retry.widdit.com/",
  "atomicFindClose",
  // Facebook borked
  "fb_xd_fragment",
  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
  // reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268
  "bmi_SafeAddOnload",
  "EBCallBackMessageReceived",
  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  "conduitPage",
  // Google tag
  "getRestrictions is not a function",
  "removeChild",
  "downsampling",
  "undefined is not an object",
  "vv",
  "WebViewJavascriptBridge",
  "zaloJSV2",
  "Can't find variable: zaloJSV2",
  /b.container[a]/,
  /getRestrictions/,
  /undefined is not an object/,
  "ttq",
  "fbq is not defined",
  "NotSupportedError",
  "globalThis is not defined"
];

const backlistMessage = [
  "ttq is not defined",
  "Can't find variable: ttq",
  "zaloJSV2 is not defined",
  "Can't find variable: zaloJSV2",
  "getRestrictions",
  "b.container[a]",
  "evaluating 'e.contentWindow.postMessage'",
  "globalThis is not defined"
];

Sentry.init({
  dsn: 'https://48bd0265fc904095a4035422d3bc4145@o83917.ingest.sentry.io/4504959207079936',
  environment: process.env.REACT_APP_ENV || 'dev',
  integrations: [new Sentry.BrowserTracing()],
  tracesSampleRate: 0.2,
  ignoreErrors: ignoreErrors,
  beforeSend(event, hint) { 
    if ( event.message && backlistMessage.includes(event.message) ) {
      return null;
    }
    return event;
  },
});

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    lng: 'vi',
    supportedLngs: ['en', 'vi'],
    resources: {
      en: {
        translation: translationEN
      },
      vi: {
        translation: translationVI
      }
    },
    fallbackLng: 'vi',
    debug: false,
    detection: {
      order: ['sessionStorage', 'cookie'],
      caches: ['sessionStorage', 'cookie'],
      lookupLocalStorage: 'i18next'
    }
  });

  ReactDOM.render(
    <BrowserRouter basename="/user">
      <App />
    </BrowserRouter>,
    document.getElementById('root')
  );
